import { axiosInstance } from '.';
import { AttributionProposal } from '../interfaces';

let entityCache: string[] = [];
let entityCacheTimestamp: number = 0;

/**
 * Get the list of entities from the Google Sheet
 * Used for Propose Attribution and Propose HC Cluster Attribution features
 * @returns The list of entities
 */
const getEntitiesSot = async (): Promise<string[]> => {
  try {
    const currentTime = Date.now();
    if (currentTime - entityCacheTimestamp < 1000 * 60 * 60 * 24) {
      return entityCache;
    }
    const endpoint = '/entity/entities_sot';
    const res = await axiosInstance.get(endpoint);

    entityCache = res.data;
    entityCacheTimestamp = Date.now();

    return entityCache;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const submitAttribution = async (data: AttributionProposal) => {
  const res = await axiosInstance.post('/entity/attribution', data);
  return res.data;
};

const submitHCClusterAttribution = async (data: AttributionProposal) => {
  const res = await axiosInstance.post('/entity/hc_cluster_attribution', data);
  return res.data;
};

export const entity = {
  getEntitiesSot,
  submitAttribution,
  submitHCClusterAttribution,
};
